








































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_diffTable,
} from '@/queries/__generated__/paychecksAndBookkeepingReconciliationReport';

@Component({})
export default class DiffTable extends Vue {
  @Prop({ required: true }) private headers!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders[];
  @Prop({ required: true }) private rows!: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_diffTable;
  @Prop({ type: Number, required: true }) private year!: number;
}
